export default {
  "content": "<path d=\"M16 16a8 8 0 100-16 8 8 0 000 16zm0 4C7 20 0 26 0 32h32c0-6-7-12-16-12z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "#CDD1D4",
    "viewBox": "0 0 32 32"
  }
};